module.exports = __webpack_public_path__ + "img/nachos_no_go.4adf2fac.jpeg";